module.exports = __webpack_public_path__ + "img/3H.a096bfcc.png";